// @ts-check
import RoleTabList from './tab-list.js';

RoleTabList.define('role-tab-list');

export default RoleTabList;
export * from './tab-list.js';

/**
 * @type {import("./tab-list-globals.js")}
 */
